import axios from "axios";
import { persistor } from "../redux/configStore";
import { clearSwrCache } from "./swrCache";
export const settings = {
  setStorageJson: (name, data) => {
    data = JSON.stringify(data);
    localStorage.setItem(name, data);
  },
  setStorage: (name, data) => {
    localStorage.setItem(name, data);
  },
  getStorageJson: (name) => {
    if (localStorage.getItem(name)) {
      const data = JSON.parse(localStorage.getItem(name));
      return data;
    }
    return; //undefined
  },
  getStore: (name) => {
    if (localStorage.getItem(name)) {
      const data = localStorage.getItem(name);
      return data;
    }
    return; //undefined
  },
  setCookieJson: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    value = JSON.stringify(value);
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  getCookieJson: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0)
        return JSON.parse(c.substring(nameEQ.length, c.length));
    }
    return null;
  },
  setCookie: (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  delete_cookie: (name) => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
  getCookie: (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  eraseCookie: (name) => {
    document.cookie =
      name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  },
};
export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL, //tất cả các hàm khi gọi api đều sử dụng domain này
  timeout: 20000,
});
//Cấu hình cho request: Client gửi api đến server
http.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      /* [Old Code]: Chỉ gửi Authorization
      Authorization: `Bearer ${settings.getCookie("access_token")}`,
      */
      
      // [New Code]: Gửi kèm X-Role-Context để Backend xác định vai trò làm việc
      Authorization: `Bearer ${settings.getCookie("access_token")}`,
      "X-Role-Context": settings.getCookie("type_user"),
    };
    return config;
  },
  (err) => {
    // console.log(err);
    return Promise.reject(err);
  }
);
//cấu hình cho response: Server sẽ trả dữ liệu về cho client
http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    //Thất bại của tất cả request sử dụng http sẽ trả vào đây
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname;
      if (currentPath !== "/login" && currentPath !== "/staff-login") {
        persistor.pause();
        persistor.flush().then(() => {
          clearSwrCache();
          settings.delete_cookie("access_token");
          settings.delete_cookie("type_user");
          window.location.assign("/login");
          return persistor.purge();
        });
      }
    }
    // console.log(error);
    return Promise.reject(error);
  }
);
